import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import LayOut from "../components/LayOut"; // Update this path if needed

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      return alert("Passwords do not match");
    }
    try {
      const res = await axios.post(
        "https://portfoliomern-mxue.onrender.com/api/v1/auth/reset-password",
        {
          token,
          newPassword,
        }
      );
      alert(res.data.message);
      navigate("/login");
    } catch (err) {
      console.error("Reset password error:", err);
      alert(err);
    }
  };

  return (
    <LayOut title={"Reset Password"}>
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="reset-password-container p-4 border rounded shadow">
          <h2 className="text-center mb-4">Reset Your Password</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                type="password"
                className="form-control"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="password"
                className="form-control"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-pink w-100">
              Reset Password
            </button>
          </form>
        </div>
      </div>
    </LayOut>
  );
};

export default ResetPassword;
